import { useI18n } from "hooks/i18n/i18n";
import React from "react";

export const Copy = () => {
  const { t } = useI18n();
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{t("settlementHistory.copy")}</title>
      <path
        d="M20 9.33301H14C13.2667 9.33301 12.6667 9.93301 12.6667 10.6663V18.6663C12.6667 19.3997 13.2667 19.9997 14 19.9997H20C20.7333 19.9997 21.3333 19.3997 21.3333 18.6663V10.6663C21.3333 9.93301 20.7333 9.33301 20 9.33301ZM20 18.6663H14V10.6663H20V18.6663ZM10 17.9997V16.6663H11.3333V17.9997H10ZM10 14.333H11.3333V15.6663H10V14.333ZM14.6667 21.333H16V22.6663H14.6667V21.333ZM10 20.333V18.9997H11.3333V20.333H10ZM11.3333 22.6663C10.6 22.6663 10 22.0663 10 21.333H11.3333V22.6663ZM13.6667 22.6663H12.3333V21.333H13.6667V22.6663ZM17 22.6663V21.333H18.3333C18.3333 22.0663 17.7333 22.6663 17 22.6663ZM11.3333 11.9997V13.333H10C10 12.5997 10.6 11.9997 11.3333 11.9997Z"
        fill="currentColor"
      />
    </svg>
  );
};
